import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedNumber, FormattedMessage } from 'react-intl';
import styles from './sbSharedSearchSuggestions.scss';
import { pageTypeConstants as pageTypes } from '../../constants/pageTypeConstants';
import { SbSharedLink } from '../SbSharedLink/SbSharedLink';

function SbSharedSearchSuggestionsComponent(props) {
    const { searchBrowse } = props;
    const suggestions = get(props, 'searchBrowse.spellCheck.suggestions');

    if (searchBrowse.pageType !== pageTypes.SEARCH || !suggestions) {
        return null;
    }

    return (
        <ul className={props.className} data-tn="search-suggestions-wrapper">
            <li className={styles.suggestion} data-tn="search-suggestions-title">
                <FormattedMessage
                    id="sb.SbSharedSearchSuggestions.suggestionText"
                    defaultMessage="For more results try"
                />
            </li>
            {suggestions.map(({ name, count, uri }) => (
                <li key={uri} className={styles.suggestion} data-tn="search-suggestion">
                    <SbSharedLink href={uri}>
                        <span className={styles.suggestionTitle}>{name}</span>(
                        <FormattedNumber value={count} />)
                    </SbSharedLink>
                </li>
            ))}
        </ul>
    );
}

SbSharedSearchSuggestionsComponent.propTypes = {
    className: PropTypes.string,
    searchBrowse: PropTypes.shape({
        pageType: PropTypes.string.isRequired,
        suggestions: PropTypes.shape({
            name: PropTypes.string.isRequired,
            count: PropTypes.number.isRequired,
            uri: PropTypes.string.isRequired,
        }),
    }),
};

export const SbSharedSearchSuggestions = createFragmentContainer(
    SbSharedSearchSuggestionsComponent,
    {
        searchBrowse: graphql`
            fragment SbSharedSearchSuggestions_searchBrowse on SearchBrowseQueryConnection {
                pageType
                spellCheck {
                    suggestions {
                        name
                        count
                        uri
                    }
                }
            }
        `,
    }
);
